<template>
  <div class="menu">
    <el-menu :router="true" class="el-menu-vertical">
      <el-menu-item index="1" :route="{name:'Generate'}">
        <span style="padding-left:6%; padding-right:6%; width:150px; overflow: auto;">
          <!--  <i class="el-icon-setting"></i> -->
          <font-awesome-icon icon="cog"/>
        </span>
        <span slot="title">Generate License</span>
      </el-menu-item>
      <el-menu-item index="2" :route="{name:'Search'}">
        <span style="padding-left:6%; padding-right:6%; width:150px; overflow: auto;">
          <!--  <i class="el-icon-search"></i> -->
          <font-awesome-icon icon="search"/>
        </span>
        <span slot="title">Search License</span>
      </el-menu-item>
      <el-menu-item index="3" :route="{name:'CustomerList'}">
          <span style="padding-left:6%; padding-right:6%; width:150px; overflow: auto;">
            <!--  <i class="el-icon-user"></i> -->
            <font-awesome-icon icon="user-tie"/>
          </span>
          <span slot="title">Customer</span>
      </el-menu-item>
      <el-menu-item index="4" :route="{name:'LicenseHistory'}">
        <span style="padding-left:6%; padding-right:6%; width:150px; overflow: auto;">
          <font-awesome-icon icon="history"/>
        </span>
        <span slot="title">License History</span>
      </el-menu-item>
      <el-menu-item index="5" :route="{name:'OpList'}">
        <span style="padding-left:6%; padding-right:6%; width:150px; overflow: auto;">
          <font-awesome-icon icon="cloud"/>
        </span>
        <span slot="title">Online OP</span>
      </el-menu-item>
      <el-menu-item index="6" v-if="this.$store.state.usertype === 1" :route="{name:'UserList'}">
        <span style="padding-left:6%; padding-right:6%; width:150px; overflow: auto;">
          <font-awesome-icon icon="user-friends"/>
        </span>
        <span slot="title">User</span>
      </el-menu-item>
      <el-menu-item index="7" :route="{name:'EventLog'}">
          <span style="padding-left:6%; padding-right:6%; width:150px; overflow: auto;">
            <font-awesome-icon icon="list-alt"/>
          </span>
          <span slot="title">Event Log</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
</style>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// Menu.vue?b572b682